import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemQuantity',
  props: {
    disabled: { type: Boolean },
    quantity: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({(e: "change", quantity: number): void}), expose: any, slots: any, attrs: any }) {




const quantities = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

function onQuantityChange(quantity: number) {
    emit("change", quantity);
}

return { __sfc: true,emit, quantities, onQuantityChange }
}

})